const $ = jQuery;

export default function mobileMenu() {
    const menuToggle = document.querySelectorAll('.js-menu-toggle');

    if(!menuToggle) return;

    if (menuToggle) {
        menuToggle.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                document.querySelector('.menu-toggle.js-menu-toggle').classList.toggle('menu-toggle--active');

                const body = document.querySelector('body');
                body.classList.toggle('menu-open');
                body.classList.toggle('hidden');
            });
        });
    }

    recalculateMain();
    dropdownMenu();

    // on resize
    window.addEventListener('resize', () => {
        recalculateMain();
        const body = document.querySelector('body');
        if (body.classList.contains('menu-open')) {
            body.classList.remove('menu-open');
            body.classList.remove('hidden');
            document.querySelector('.menu-toggle.js-menu-toggle').classList.remove('menu-toggle--active');
        }
    });
}

function recalculateMain() {
    const main = document.querySelector('.resp-menu__main');

    if(!main) return;
    main.style.maxHeight = `unset`;
    main.style.height = `100%`;
    const header = document.querySelector('.resp-menu__header');
    const footer = document.querySelector('.resp-menu__footer');

    if (main) {
        let mainHeight = main.offsetHeight - (header.offsetHeight + footer.offsetHeight);
        main.style.maxHeight = `${mainHeight}px`;
    }
}

function dropdownMenu() {
    const dropdownToggle = $('.js-resp-menu-dropdown--toggle');
    const dropdownSubToggle = $('.resp-menu__dropdown-item-title');

    if(!dropdownToggle) return;

    if (dropdownToggle) {
        dropdownToggle.on('click', function () {
            $(this).toggleClass('active');
            $(this).siblings('.resp-menu__dropdown-container').slideToggle(300).toggleClass('active');
        });
    }

    if (dropdownSubToggle) {
        dropdownSubToggle.on('click', function () {
            $(this).toggleClass('active');
            $(this).siblings('.resp-menu__dropdown-subcontainer').slideToggle(300).toggleClass('active');
        });
    }
}
